const STORAGE_KEY = 'kitchenlabid';

/**
 * KitchenLab sends the customer to e.g. /boka-mote?klID=983321. The id has to survive the
 * customer clicking around before opening the booking modal, so it is picked up on every page
 * load (see main.ts) and kept for the browser session. Both klID and kitchenlabid are accepted.
 */
function readFromUrl(): string | null {
    let found: string | null = null;
    new URLSearchParams(window.location.search).forEach((value, key) => {
        const name = key.toLowerCase();
        if (!found && value && (name === 'klid' || name === 'kitchenlabid')) {
            found = value;
        }
    });
    return found;
}

/** Remembers the id when the current URL carries one. Safe to call on every page load. */
export function captureKitchenLabId(): void {
    const fromUrl = readFromUrl();
    if (!fromUrl) {
        return;
    }
    try {
        window.sessionStorage.setItem(STORAGE_KEY, fromUrl);
    } catch (e) {
        // Storage blocked - the id is still read from the URL while the customer stays on this page.
    }
}

/** The customer's KitchenLab id: from the URL if present, otherwise the one remembered earlier. */
export function getKitchenLabId(): string | null {
    const fromUrl = readFromUrl();
    if (fromUrl) {
        return fromUrl;
    }
    try {
        return window.sessionStorage.getItem(STORAGE_KEY);
    } catch (e) {
        return null;
    }
}
